<template> 
    <modal
      name="eFileConfirmPopupModal"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="600px"
      height="auto"
    >
      <div class="v-modal profile_details_modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">e-File</h2>
          <span @click="hideMe()">
            <em class="material-icons">close</em>
          </span>
        </div>
        <form v-if="!isDraftResume" @submit.prevent data-vv-scope="changeCaseTypeForm"  @keydown.enter.prevent>
          <div class="form-container padb20">
            <h6 class="popup-title">{{'A draft has already been created with account '+ checkProperty(petitionDetails,'eFiledAccountEmail')+'. The process can be resumed only with the same account. Continue with the same account.'}}</h6>
          </div>
          <div class="popup-footer relative">
            <span class="loader" v-if="caseTypeCahnging"
              ><img src="@/assets/images/main/loader.gif"
            /></span>
  
            <vs-button
              color="dark"
              @click="startNew()"
              class="cancel"
              type="filled"
              >File with New Account</vs-button
            >
            <vs-button
              color="success"
              @click="continueEfile()"
              class="save"
              type="filled"
              >Proceed
            </vs-button>
          </div>
        </form>
        <form v-else @submit.prevent data-vv-scope="changeCaseTypeForm"  @keydown.enter.prevent>
          <div class="form-container padb20">
            <h6 class="popup-title">{{'It is observed that USCIS filing for this case was already in progress. You may resume or refill the form from beginning. If you restart, any changes or updates you made in USCIS form will be lost and the form will be filled in with the case details available in ImmiBox. Do you want to resume the process from where it was left?'}}</h6>
          </div>
          <div class="popup-footer relative">
            <span class="loader" v-if="caseTypeCahnging"
              ><img src="@/assets/images/main/loader.gif"
            /></span>
  
            <vs-button
              color="dark"
              @click="startNew()"
              class="cancel"
              type="filled"
              >No, Restart from beginning</vs-button
            >
            <vs-button
              color="success"
              @click="resumeEfile()"
              class="save"
              type="filled"
              >Yes, Resume
            </vs-button>
          </div>
        </form>


      </div>
    </modal>
  </template>
  <script>
  export default {
    methods: {
      continueEfile() {
        if (this.checkProperty(this.petitionDetails, 'eFileDraftLastStepUrl')) {
         this.isDraftResume=true
        } else {
          const existingButton = document.getElementById('submit-efill')
          if (existingButton) {
            existingButton.click()
          }
          this.hideMe(false)
        }
      },
      resumeEfile() {
        const existingButton = document.getElementById('submit-efill')
            if (existingButton) {
                existingButton.click()
            }
            this.hideMe(false)
      },
      hideMe(reloadCase=true) {
        this.$modal.hide("eFileConfirmPopupModal");
        if(reloadCase){
            this.$emit("updatepetition");
        }
        this.$emit("hideMe");
      },
      startNew() {
        let postData = {
          petitionId: this.checkProperty(this.petitionDetails, '_id'),
        };
        this.$store.dispatch("commonAction", { "data": postData, "path": "/petition/delete-efile-application-number" }).then((response) => {
          const existingButton = document.getElementById('submit-efill')
          if (existingButton) {
            existingButton.click()
          }
          this.hideMe()
        }).catch((err) => {
          const existingButton = document.getElementById('submit-efill')
          if (existingButton) {
            existingButton.click()
          }
          this.hideMe()
        })
      },
    },
    mounted() {
      this.$modal.show("eFileConfirmPopupModal");
  
    },
    data: () => ({
      caseTypeCahnging: false,
      formerrors: {
        msg: "",
      },
      isDraftResume:false
      
    }),
    props: {
      petitionDetails: {
        type: Object,
        default: null,
      },
    },
  };
  </script>